import Cookie from "universal-cookie";
import {useEffect, useState} from "react";
import variables from "../../variables/env.js";

export default function getCountCesta() {
    const [data, setData] = useState('');

    async function getData() {
        const response = await fetch(variables.apiurl +'index.php/servicios/contadorProductoCesta',{
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                cestaCookie : variables.getIdCesta(),
                token: variables.auth('token'),
            })
        });
        const data = await response.json();
        if (data && data.result){
            let d = (String(data.result) === '0' || Number(data.result) === 0) ? '' : data.result;
            setData(d);
        }else{
            setData('');
        }
    }

    useEffect(() => {
        getData();

    }, []);

    return data;
}
